class ChatFormFlowTracking {
  constructor(el) {
    this.el = el;
  }

  trackBtnClick = (params) => {
    window.GTMtracker?.pushEvent({
      event: 'gtm_custom_click',
      data: {
        click_source: 'upfront-form',
        ...params,
      },
    });
  }

  formStatusTracking = (status, attributes) => {
    window.GTMtracker?.pushEvent({
      event: 'gtm_custom_click',
      data: {
        click_source: 'upfront-form',
        form_status: status,
        ...attributes,
      },
    });
  };
}

export default ChatFormFlowTracking;
